module.exports = __webpack_public_path__ + "img/IMGcrop_3362.d9c579cd.jpeg";